<script setup lang="ts">
import PageFooter from '../../../components/clients/common/PageFooter.vue';
import { ref } from 'vue';
import { useStateStore } from '../../../stores/state.store';
import SaveDateDescription from '@/components/clients/saveDate/SaveDateDescription.vue';
import BluredImage from '@/components/clients/saveDate/BluredImage.vue';

const stateStore = useStateStore();

const backgroundColor = ref(stateStore.getColors.backgroundColor);
</script>

<template>
  <div class="save-date-container">
    <BluredImage />
    <div class="save-date">
      <SaveDateDescription />
    </div>
    <PageFooter />
  </div>
</template>

<style lang="scss" scoped>
.save-date-container {
  background-color: v-bind(backgroundColor);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.save-date {
  flex: 1 0 auto;
  position: relative;
  display: flex;
  height: 100%;
}
</style>
